import { input, signal } from '@angular/core';
import * as i0 from "@angular/core";
function AgentStepsComponent_Conditional_0_For_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "li", 5)(1, "div", 6);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(3, "div", 7);
    i0.ɵɵtext(4);
    i0.ɵɵdomElementEnd()();
} if (rf & 2) {
    const step_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(step_r3.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(step_r3.description);
} }
function AgentStepsComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵdomElementStart(0, "button", 0);
    i0.ɵɵdomListener("click", function AgentStepsComponent_Conditional_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleSteps()); });
    i0.ɵɵdomElementStart(1, "div", 1);
    i0.ɵɵtext(2, "See Details");
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElement(3, "div", 2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(4, "div", 3)(5, "ul", 4);
    i0.ɵɵrepeaterCreate(6, AgentStepsComponent_Conditional_0_For_7_Template, 5, 2, "li", 5, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵdomElementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-expanded", ctx_r1.showSteps());
    i0.ɵɵadvance(4);
    i0.ɵɵclassProp("collapse", !ctx_r1.showSteps())("show", ctx_r1.showSteps())("mb-2", ctx_r1.showSteps());
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.steps());
} }
export class AgentStepsComponent {
    constructor() {
        this.steps = input.required(...(ngDevMode ? [{ debugName: "steps" }] : []));
        this.showSteps = signal(false, ...(ngDevMode ? [{ debugName: "showSteps" }] : []));
    }
    toggleSteps() {
        this.showSteps.update((x) => !x);
    }
}
AgentStepsComponent.ɵfac = function AgentStepsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentStepsComponent)(); };
AgentStepsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentStepsComponent, selectors: [["ycn-agent-steps"]], inputs: { steps: [1, "steps"] }, decls: 1, vars: 1, consts: [["role", "button", "aria-controls", "agentStepsDetails", 1, "btn", "btn-transparent-rounded", "mt-2", "mb-2", 3, "click"], [1, "text-thin"], [1, "collapse-chevron", "align-self-center"], ["id", "agentStepsDetails"], [1, "list-steps"], [1, "list-steps-item"], [1, "list-steps-title"], [1, "list-steps-description"]], template: function AgentStepsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, AgentStepsComponent_Conditional_0_Template, 8, 7);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.steps().length > 0 ? 0 : -1);
    } }, encapsulation: 2, changeDetection: 0 });
